import React from 'react';

/**
 * Icons for the auth pages. Paths are copied verbatim from
 * .claude/login-prototype.html (v2) — same viewBox, stroke widths and caps.
 */
const base = (size, extra) => ({
  width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
  stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round',
  'aria-hidden': true, focusable: 'false', ...extra,
});

export const AlertIcon = ({ size = 20 }) => (
  <svg {...base(size)}><circle cx="12" cy="12" r="9" /><path d="M12 8v5M12 16.5v.5" /></svg>
);
export const ClockIcon = ({ size = 20 }) => (
  <svg {...base(size)}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
);
export const WifiOffIcon = ({ size = 20 }) => (
  <svg {...base(size)}>
    <path d="M2 2l20 20M8.5 16.5a5 5 0 0 1 7 0M5 13a10 10 0 0 1 5.2-2.8M19 13a10 10 0 0 0-2.4-1.8M2 8.8a15 15 0 0 1 4.2-2.6M22 8.8A15 15 0 0 0 11 5" />
    <path d="M12 20h.01" />
  </svg>
);
export const CheckIcon = ({ size = 20 }) => (
  <svg {...base(size, { strokeWidth: 2.2 })}><circle cx="12" cy="12" r="9" /><path d="M8 12.5l2.5 2.5 5-5.5" /></svg>
);
export const InfoIcon = ({ size = 20 }) => (
  <svg {...base(size)}><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 7.5v.5" /></svg>
);
export const EyeIcon = ({ size = 20 }) => (
  <svg {...base(size)}><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></svg>
);
export const EyeOffIcon = ({ size = 20 }) => (
  <svg {...base(size)}><path d="M3 3l18 18M10.6 5.1A10.7 10.7 0 0 1 12 5c6.4 0 10 7 10 7a17 17 0 0 1-3.1 3.9M6.6 6.6A17 17 0 0 0 2 12s3.6 7 10 7a10 10 0 0 0 5.4-1.6M9.9 9.9a3 3 0 0 0 4.2 4.2" /></svg>
);

const big = (stroke, strokeWidth = 1.8) => ({
  width: 28, height: 28, viewBox: '0 0 24 24', fill: 'none', stroke,
  strokeWidth, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true, focusable: 'false',
});
export const MailBig = () => (
  <svg {...big('var(--ppa-honey-deep)')}><rect x="3" y="5" width="18" height="14" rx="2.5" /><path d="M3.5 6.5l8.5 6.5 8.5-6.5" /></svg>
);
export const KeyBig = () => (
  <svg {...big('var(--ppa-honey-deep)')}><circle cx="8" cy="15" r="4" /><path d="M11 12l9-9M17 6l3 3M14 9l2 2" /></svg>
);
export const TeamBig = () => (
  <svg {...big('var(--ppa-honey-deep)')}>
    <circle cx="9" cy="8" r="3.5" /><path d="M2.5 20a6.5 6.5 0 0 1 13 0" /><circle cx="17" cy="9" r="2.5" /><path d="M16.5 14.2A5 5 0 0 1 21.5 19" />
  </svg>
);
export const ClockBig = () => (
  <svg {...big('var(--ppa-honey-deep)')}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
);
export const OkBig = () => (
  <svg {...big('var(--ppa-jade)', 2)}><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
);
export const BrokenBig = () => (
  <svg {...big('var(--ppa-coral)')}>
    <path d="M9.5 14.5l5-5M8 11l-2.5 2.5a3.5 3.5 0 0 0 5 5L13 16M16 13l2.5-2.5a3.5 3.5 0 0 0-5-5L11 8" /><path d="M4 4l2 2M20 20l-2-2" />
  </svg>
);

const panel = { width: 20, height: 20, viewBox: '0 0 24 24', fill: 'none', stroke: '#E9A23E', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true, focusable: 'false' };
export const RemoteIcon = () => (
  <svg {...panel}><rect x="7" y="2.5" width="10" height="19" rx="3" /><circle cx="12" cy="8" r="2" /><path d="M10 13h4M10 16.5h4" /></svg>
);
export const PromoIcon = () => (
  <svg {...panel}><rect x="2.5" y="4" width="19" height="13" rx="2" /><rect x="12.5" y="10.5" width="7" height="4.5" rx="1" /><path d="M8 21h8" /></svg>
);
export const PulseIcon = () => (
  <svg {...panel}><path d="M3 12h4l2.5-6 5 12 2.5-6h4" /></svg>
);
